import { render, staticRenderFns } from "./TagsSettings.vue?vue&type=template&id=68690b78&scoped=true&"
import script from "./TagsSettings.vue?vue&type=script&lang=js&"
export * from "./TagsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68690b78",
  null
  
)

export default component.exports